<template>
  <div id="app">
    <div class="app-box">
      <div class="info-box">
        <img class="logo" src="https://s5.danmaku.live/web/logo.png" alt="弹幕库">
        <div class="subtitle">哔哩哔哩直播助手</div>
        <div class="update-info">
          <div class="version-info">
            <div class="title">弹幕库 v2.2.2 <span class="date">2020-06-01</span></div>
            <ul>
              <li class="detail">修复无法获取弹幕的问题</li>
              <li class="detail">由于作者的时间和精力有限 弹幕库目前会暂停功能维护 同时会下线BGM点歌板和唱见点歌板的在线伴奏歌词功能</li>
              <li class="detail">非常感谢各位一直以来的陪伴和支持 虽然江湖路远 但我始终坚信 念念不忘 必有回响</li>
            </ul>
          </div>
          <div class="version-info">
            <div class="title">弹幕库 v2.2.1 <span class="date">2020-01-21</span></div>
            <ul>
              <li class="detail">修复无法正常登录问题</li>
              <li class="detail">尝试修复模块列表获取失败的问题</li>
            </ul>
          </div>
          <div class="version-info">
            <div class="title">弹幕库 v2.2.0 <span class="date">2019-11-15</span></div>
            <ul>
              <li class="detail">更新部分内部接口</li>
              <li class="detail">修复不能发送弹幕的问题</li>
              <li class="detail">修复部分弹幕获取失败问题</li>
            </ul>
          </div>
          <div class="version-info">
            <div class="title">弹幕库 v2.1.1 <span class="date">2019-05-31</span></div>
            <ul>
              <li class="detail">修复评论弹幕不能正常展示的问题</li>
            </ul>
          </div>
          <div class="version-info">
            <div class="title">弹幕库 v2.1.0 <span class="date">2019-01-30</span></div>
            <ul>
              <li class="detail">模块资源加载失败自动重试机制</li>
              <li class="detail">窗口标题优化</li>
              <li class="detail">内部接口更新</li>
              <li class="detail">内核更新</li>
            </ul>
          </div>
          <div class="version-info">
            <div class="title">弹幕库 v2.0.0 <span class="date">2018-12-22</span></div>
            <ul>
              <li class="detail">v2版本里 礼物触发的弹幕（如： 小电视、节奏风暴、嗨翻全城等...）会被自动过滤 在弹幕视图 历史记录 统计 语音播报以及OBS模块中都不会展示和记录 但是节奏风暴的内容会在弹幕视图中随着金瓜子礼物提示展示</li>
              <li class="detail">底层支持多房间同时监听</li>
              <li class="detail">功能组件全部模块化 支持热更新</li>
              <li class="detail">自动保存弹幕日志 用于浏览历史弹幕和统计</li>
            </ul>
            <div class="section">新增</div>
            <ul>
              <li class="detail">快速开播模块<br/>可以快速设置直播间标题 分区 封面图 开关直播 更新直播间公告 获取推流码</li>
              <li class="detail">礼物素材模块<br/>可以查看并保存直播礼物动图/静态图到本地</li>
              <li class="detail">唱见点歌板模块<br/>专为唱见主播设计的点歌板模块 可以搜索伴奏、歌词 支持本地曲库 支持修改点歌指令 支持选择音频输出设备</li>
              <li class="detail">BGM点歌板模块<br/>新增空闲列表功能 支持歌单导入 支持修改点歌指令 支持选择音频输出设备</li>
              <li class="detail">工具栏模块<br/>可以快捷发送弹幕 可以快速唤醒弹幕库主窗口功能</li>
              <li class="detail">弹幕视图OBS模块<br/>为OBS提供的浏览器源模块 主要解决弹幕视图无法被捕捉的问题 具体的使用引导在模块设置中有说明 需配合OBS Studio版本使用</li>
            </ul>
            <div class="section">更改</div>
            <ul>
              <li class="detail">弹幕视图<br/>支持窗口宽度、高度调整 支持背景色、字体色、文本字体设置 金瓜子礼物浮层提示 平滑弹幕进入动画</li>
              <li class="detail">历史视图<br/>支持按天查看历史弹幕</li>
              <li class="detail">礼物统计<br/>支持按天查看统计信息 金瓜子礼物单独计数 支持统计上船数量</li>
              <li class="detail">语音播报<br/>支持自定义播报内容 支持评论弹幕过滤机制</li>
            </ul>
            <div class="section">修复</div>
            <ul>
              <li class="detail">修复礼物、头衔、舰长等图片的展示问题</li>
              <li class="detail">修复无法发送弹幕的问题</li>
            </ul>
          </div>
        </div>
        <div class="download-box">
          <div class="download-button" @click="download">
            <p class="platform">下载{{platform}}版</p>
            <p class="version">{{version}}</p>
          </div>
        </div>
      </div>
      <div class="sample-box">
        <img class="sample-pic" src="https://s5.danmaku.live/web/sample.png" alt="弹幕库软件示例">
      </div>
    </div>
    <footer>
      <a class="beian" href="http://www.beian.miit.gov.cn">津ICP备18003022号-1</a>
      <div class="friend-link">
        <a class="upyun-logo" href="https://www.upyun.com/"><img src="https://s5.danmaku.live/web/upyun.png" alt="又拍云"></a>
      </div>
    </footer>
  </div>
</template>

<script>
import 'bubbly-bg'
export default {
  data () {
    return {
      version: 'v2.2.2',
      platform: 'Windows'
    }
  },
  created () {
    this.platform = this.getOS() || 'Windows'
  },
  mounted () {
    window.bubbly({
      colorStart: '#429ffd',
      colorStop: '#0960bd'
    })
  },
  methods: {
    getOS () {
      var userAgent = window.navigator.userAgent

      var platform = window.navigator.platform

      var macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K']

      var windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE']

      var iosPlatforms = ['iPhone', 'iPad', 'iPod']

      var os = null

      if (macosPlatforms.indexOf(platform) !== -1) {
        os = 'Mac'
      } else if (iosPlatforms.indexOf(platform) !== -1) {
        os = 'Windows'
      } else if (windowsPlatforms.indexOf(platform) !== -1) {
        os = 'Windows'
      } else if (/Android/.test(userAgent)) {
        os = 'Windows'
      } else if (!os && /Linux/.test(platform)) {
        os = 'Linux'
      }

      return os
    },
    download () {
      if (this.platform === 'Windows') {
        window.location.href = 'http://s2.danmaku.live/弹幕库-windows-v2.2.2.7z'
      } else if (this.platform === 'Mac') {
        window.location.href = 'http://s2.danmaku.live/弹幕库-mac-v2.2.2.zip'
      } else {
        window.location.href = 'http://s2.danmaku.live/弹幕库-linux-v2.2.2.zip'
      }
    }
  }
}
</script>

<style lang="stylus">
#app
  position relative
  height 100vh
  font-family 'Avenir', Helvetica, Arial, sans-serif
  background-color transparent

.app-box
  position absolute
  top 50%
  left 50%
  transform translate3d(-50%, -50%, 0)
  width 1120px
  height 500px
  display flex
.info-box
  width 320px
  .logo
    margin 0 auto
    display block
    height 64px
    border-radius 32px
    box-shadow 0 2px 2px rgba(0, 0, 0, .2)
  .subtitle
    margin 10px 0
    width 100%
    font-size 16px
    line-height 24px
    font-weight bold
    text-align center
    color #ffffff
  .update-info
    margin 0 15px
    height 300px
    border-radius 5px
    background-color rgba(0, 0, 0, .2)
    overflow auto
    text-align left
    color #ffffff
    &::-webkit-scrollbar
      width 4px
    &::-webkit-scrollbar-thumb
      border-radius 2px
      background-color rgba(0, 0, 0, .4)
  .version-info
    margin-bottom 10px
    padding 10px
    padding-bottom 0
    text-align left
    ul
      margin 5px 0
      padding-inline-start 18px
    .title
      margin 0
      font-size 16px
      line-height 24px
      font-weight bold
      .date
        display inline-block
        float right
        margin-top 2px
        font-size 14px
        line-height 22px
    .section
      margin 0
      margin-top 5px
      font-size 13px
      line-height 18px
      font-weight bold
    .detail
      font-size 13px
      line-height 16px
  .download-button
    margin 10px 70px
    margin-bottom 0
    padding 10px 5px
    background-color #f1c550
    border-bottom 4px solid #ff8f56
    border-radius 10px
    font-weight bold
    color #ffffff
    box-sizing border-box
    text-align center
    user-select none
    &:hover
      margin-top 14px
      border-bottom-width 0
      background-color #fadc6d
    .platform
      margin 0
      font-size 20px
      line-height 32px
    .version
      margin 0
      font-size 18px
      line-height 20px
.sample-box
  width 800px
  .sample-pic
    display block
    width 800px
    height 500px
footer
  position absolute
  bottom 0
  width 100%
  height 36px
  background-color #323232
  .beian
    margin 0
    display block
    font-size 12px
    line-height 36px
    text-align center
    color #ffffff
  .friend-link
    position absolute
    right 0
    bottom 0
    margin 0 10px
    font-size 0
  .upyun-logo
    display block
    font-size 0
    img
      height 32px
</style>
